<template>
    <div>
        <vue-headful
                title="Falk Huth | IT-Projekte"
                description="Vorstellung ausgewählter IT-Projekte von Falk Huth"
        />
        <md-card md-with-hover>
            <md-ripple>
                <md-card-header>
                    <div class="md-title">Vorstellung ausgewählter IT-Projekte</div>
                    <div class="md-subhead">
                        Muss noch gemacht werden
                    </div>
                </md-card-header>

                <md-card-content>
                    <div class="md-layout">
                        <div class="md-layout-item md-size-100 md-xsmall-size-100">
                        </div>
                    </div>
                </md-card-content>
            </md-ripple>
        </md-card>
    </div>
</template>

<script>
    export default {
        name: "Projekte"
    }
</script>

<style lang="scss" scoped>
    .md-subheader {
        padding-left: 0!important;
    }
</style>
